(function(){'use strict';
function initSlider(){
  var hero=document.getElementById('v1Hero');
  if(!hero)return;
  var slides=hero.querySelectorAll('.v1-hero__slide');
  var dots=hero.querySelectorAll('.v1-hero__dot');
  var prevBtn=hero.querySelector('.v1-hero__prev');
  var nextBtn=hero.querySelector('.v1-hero__next');
  if(!slides.length)return;
  var current=0,timer,INTERVAL=6500;
  var touchStartX=0;
  function go(n){
    slides[current].classList.remove('is-active');
    if(dots[current])dots[current].classList.remove('is-active');
    current=(n+slides.length)%slides.length;
    slides[current].classList.add('is-active');
    if(dots[current])dots[current].classList.add('is-active');
  }
  function resetTimer(){
    clearInterval(timer);
    timer=setInterval(function(){go(current+1);},INTERVAL);
  }
  dots.forEach(function(dot,i){
    dot.addEventListener('click',function(){go(i);resetTimer();});
  });
  if(prevBtn)prevBtn.addEventListener('click',function(){go(current-1);resetTimer();});
  if(nextBtn)nextBtn.addEventListener('click',function(){go(current+1);resetTimer();});
  document.addEventListener('keydown',function(e){
    if(e.key==='ArrowLeft'){go(current-1);resetTimer();}
    if(e.key==='ArrowRight'){go(current+1);resetTimer();}
  });
  hero.addEventListener('touchstart',function(e){touchStartX=e.changedTouches[0].screenX;},{passive:true});
  hero.addEventListener('touchend',function(e){
    var diff=touchStartX-e.changedTouches[0].screenX;
    if(Math.abs(diff)>50){diff>0?go(current+1):go(current-1);resetTimer();}
  },{passive:true});
  hero.addEventListener('mouseenter',function(){clearInterval(timer);});
  hero.addEventListener('mouseleave',resetTimer);
  resetTimer();
}
function initRail(){
  var rail=document.querySelector('.v1-carousel__track');
  if(!rail)return;
  var down=false,startX,scrollLeft;
  rail.addEventListener('mousedown',function(e){down=true;rail.classList.add('is-dragging');startX=e.pageX-rail.offsetLeft;scrollLeft=rail.scrollLeft;});
  rail.addEventListener('mousemove',function(e){if(!down)return;e.preventDefault();rail.scrollLeft=scrollLeft-(e.pageX-rail.offsetLeft-startX)*1.25;});
  ['mouseup','mouseleave'].forEach(function(ev){rail.addEventListener(ev,function(){down=false;rail.classList.remove('is-dragging');});});
}
function init(){initSlider();initRail();}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
